import endpoints from "config/endpoints";
import React from "react";
import Modal from "react-modal";
import ImportFormContainer from "./ImportFormContainer";

const MODAL_STYLES = {
  content: {
    bottom: "auto",
    fontFamily: "system-ui",
    left: "50%",
    marginRight: "-50%",
    right: "auto",
    top: "50%",
    transform: "translate(-50%, -50%)",
  },
  overlay: {
    zIndex: 901,
  },
};

const IMPORT_TYPES = {
  items: {
    endpoint: endpoints.importItems,
    modalHeading: "Import items",
  },
  workOrders: {
    endpoint: endpoints.importWorkOrders,
    modalHeading: "Import work orders",
  },
};

export default function ImportModal({ importKey, modalIsOpen, onClose }) {
  const importType = IMPORT_TYPES[importKey];

  const renderImportForm = () => (
    <>
      <h2>{importType.modalHeading}</h2>
      <ImportFormContainer endPoint={importType.endpoint} onCancel={onClose} />
    </>
  );

  return (
    <Modal isOpen={modalIsOpen} onRequestClose={onClose} style={MODAL_STYLES}>
      {importType && renderImportForm()}
    </Modal>
  );
}
